import { render, staticRenderFns } from "./admin-title.vue?vue&type=template&id=00c76d97&scoped=true"
import script from "./admin-title.vue?vue&type=script&lang=js"
export * from "./admin-title.vue?vue&type=script&lang=js"
import style0 from "./admin-title.vue?vue&type=style&index=0&id=00c76d97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c76d97",
  null
  
)

export default component.exports